// extracted by mini-css-extract-plugin
export default {"welcomeToOtusoneContainer":"WelcomeToOtusone_welcomeToOtusoneContainer__jjUCu","cardContainer":"WelcomeToOtusone_cardContainer__VOXWs"};